import type {
  FoodActivity,
  DeepPartial,
} from "@tandemdiabetes/sugarmate-api-react-client"

import { NutritionDetail } from "./NutritionDetail"
import styles from "./NutritionDisplay.module.scss"
import { NutritionModal } from "./NutritionModal"
import { usePolyglot } from "src/contexts"
import { round } from "src/utils"

const polyglotPrefix = "components.entry_modal.food."

interface Props {
  activity?: DeepPartial<FoodActivity>;
  updateActivity: (a: DeepPartial<FoodActivity>) => void;
  readOnly?: boolean;
}

export function NutritionDisplay(props: Props) {
  const {
    activity,
    updateActivity,
    readOnly = false,
  } = props

  const polyglot = usePolyglot()

  const nutritionDetailContent = (
    <div className={styles.nutritionDisplay}>
      <NutritionDetail
        id="food-entry-modal-protein-detail"
        label={polyglot.t(`${polyglotPrefix}protein.label_detail`)}
        unit={polyglot.t(`${polyglotPrefix}protein.label_unit`)}
        value={typeof activity?.protein === "number" ? round(
          activity.protein,
          1,
        ) : undefined}
        readOnly={readOnly}
      />
      <NutritionDetail
        id="food-entry-modal-fat-detail"
        label={polyglot.t(`${polyglotPrefix}fat.label_detail`)}
        unit={polyglot.t(`${polyglotPrefix}fat.label_unit`)}
        value={typeof activity?.fat === "number" ? round(
          activity.fat,
          1,
        ) : undefined}
        readOnly={readOnly}
      />
      <NutritionDetail
        id="food-entry-modal-sugar-detail"
        label={polyglot.t(`${polyglotPrefix}sugar.label_detail`)}
        unit={polyglot.t(`${polyglotPrefix}sugar.label_unit`)}
        value={typeof activity?.sugar === "number" ? round(
          activity.sugar,
          1,
        ) : undefined}
        readOnly={readOnly}
      />
      <NutritionDetail
        id="food-entry-modal-fiber-detail"
        label={polyglot.t(`${polyglotPrefix}fiber.label_detail`)}
        unit={polyglot.t(`${polyglotPrefix}fiber.label_unit`)}
        value={typeof activity?.fiber === "number" ? round(
          activity.fiber,
          1,
        ) : undefined}
        readOnly={readOnly}
      />
      <NutritionDetail
        id="food-entry-modal-calories-detail"
        label={polyglot.t(`${polyglotPrefix}calories.label_detail`)}
        unit=""
        value={typeof activity?.calories === "number" ? round(
          activity.calories,
          1,
        ) : undefined}
        readOnly={readOnly}
      />
    </div>
  )

  return readOnly ? (
    nutritionDetailContent
  ) : (
    <NutritionModal
      activity={activity}
      updateActivity={updateActivity}
    >
      {nutritionDetailContent}
    </NutritionModal>
  )
}
